import {
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BadgeType } from '../../../../common/enums';
import { getFormattedTestId } from '../../Content/ContentCommonFunctions';
import { usePartnerProfileConfig } from '../Enrollment/usePartnerProfileConfig';
import { Badge } from '../../../../common/Badge';

export const PartnerHighlightsSection = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { highlights } = usePartnerProfileConfig();

  if (!highlights || highlights.length === 0) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          padding: theme.spacing(2),
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: theme.spacing(1.5),
          alignSelf: 'stretch',
          borderRadius: theme.spacing(2.5),
          border: `1px solid ${theme.palette.grey[200]}`,
        }}>
        <Typography variant='body7'>
          {t('partnerDetails.highlights')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: theme.spacing(1),
            flexWrap: 'wrap',
          }}>
          {highlights?.map((perk, index) => (
            <Box
              data-testid={`partners-individual-perk-${getFormattedTestId(perk)}`}
              key={index}>
              <Badge
                badgeType={BadgeType.Checkmark}
                badgeText={perk}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};
